module.exports = __webpack_public_path__ + "img/M4.66fe8d93.svg";